<div class="dialog">
  <div class="dialog__wrapper">
    <button type="button" class="dialog__close" (click)="close()">
      <i class="icon-close"></i>
    </button>
    <ng-container #dialogContent></ng-container>
  </div>
</div>
<div class="dialog__background"></div>
